module.exports = __webpack_public_path__ + "static/media/life.649f5736.png";